import React from "react";

interface IOnPageNavigationProps {
    Links: Array<{ Url: string; Title: string }>;
}

function OnPageNavigation(props: IOnPageNavigationProps) {
    return (
        <div className="on-page-navigation">
            {props.Links.map((val, idx) => (
                <a key={idx} href={val.Url}>
                    {val.Title}
                </a>
            ))}
        </div>
    );
}

export default OnPageNavigation;
